export default __webpack_public_path__ + "static/media/mg-title-en.4051f960.webp";